import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Home, ClipboardList, TrendingUp, Package, MapPin, Upload,
  Send, Settings, Users, LayoutDashboard, FilePlus2, History, Tag,
} from 'lucide-react';

const adminNav = [
  { to: '/app/overview', label: 'Overview', icon: Home },
  { to: '/app/requisitions', label: 'All requisitions', icon: ClipboardList },
  { to: '/app/reports', label: 'Reports', icon: TrendingUp },
  { to: '/app/items', label: 'Item master', icon: Package },
  { to: '/app/ebos', label: 'EBO master', icon: MapPin },
  { to: '/app/brands', label: 'Brand master', icon: Tag },
  { to: '/app/sales', label: 'Sales data', icon: Upload },
  { to: '/app/automailer', label: 'Automailer', icon: Send },
  { to: '/app/settings', label: 'Portal settings', icon: Settings },
  { to: '/app/users', label: 'Users & roles', icon: Users },
];

// SuperAdmin gets the standard admin nav PLUS a Backfill entry that opens
// the raise-requisition screen ready for the historical-entry toggle.
const superAdminNav = [
  ...adminNav,
  { to: '/app/raise?backfill=1', label: 'Backfill historical', icon: History },
];

const managerNav = [
  { to: '/app/overview', label: 'Overview', icon: Home },
  { to: '/app/requisitions', label: 'All requisitions', icon: ClipboardList },
  { to: '/app/reports', label: 'Reports', icon: TrendingUp },
  { to: '/app/ebos', label: 'EBO master', icon: MapPin },
  { to: '/app/sales', label: 'Sales data', icon: Upload },
];

const eboNav = [
  { to: '/app/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/app/raise', label: 'Raise requisition', icon: FilePlus2 },
  { to: '/app/my-requisitions', label: 'My requisitions', icon: ClipboardList },
];

const warehouseNav = [
  { to: '/app/overview', label: 'Overview', icon: Home },
  { to: '/app/requisitions', label: 'All requisitions', icon: ClipboardList },
  { to: '/app/items', label: 'Item master', icon: Package },
];

function navFor(role) {
  if (role === 'EBO') return eboNav;
  if (role === 'Warehouse' || role === 'Logistics') return warehouseNav;
  if (role === 'AllIndiaManager' || role === 'ZoneManager' || role === 'RetailManager') return managerNav;
  if (role === 'SuperAdmin') return superAdminNav;
  return adminNav; // Admin
}

export default function Sidebar() {
  const { user, theme } = useAuth();
  const items = navFor(user?.role);

  return (
    <aside className="w-[220px] shrink-0 border-r border-[#E7E2D3] bg-[#F5F1E7] min-h-screen flex flex-col">
      <div className="px-5 pt-6 pb-4 flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-[10px] flex items-center justify-center text-white text-[13px] font-bold tracking-[0.6px]"
          style={{ background: theme.primary }}
        >CF</div>
        <div>
          <div className="font-serif text-[19px] leading-none tracking-[0.5px]" style={{ color: theme.primary }}>CORE FUTURE</div>
          <div className="text-[9.5px] tracking-[0.14em] text-[#7a6f5c] mt-1 font-mono uppercase">Tester Requisition Portal</div>
        </div>
      </div>

      <nav className="px-3 mt-3 flex-1">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${label.toLowerCase().replace(/\s+/g, '-')}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-[14px] mb-1 transition-colors ${
              isActive
                ? 'bg-[rgba(156,61,84,0.10)] font-semibold'
                : 'text-[#443C31] hover:bg-[rgba(156,61,84,0.06)]'
            }`}
            style={({ isActive }) => (isActive ? { color: theme.primary } : {})}
          >
            <Icon size={16} strokeWidth={1.75} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-5 pt-4 pb-5 border-t border-[#E7E2D3] text-[9.5px] tracking-[0.14em] uppercase text-[#7a6f5c] leading-relaxed">
        FUTURE MAKEUP<br/>INDIA PVT LTD
      </div>
    </aside>
  );
}
